// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#god-index-container .swiper-pagination-fraction,\n#god-index-container .swiper-pagination-custom,\n#god-index-container .swiper-container-horizontal > .swiper-pagination-bullets {\n  height: 0.8rem;\n}\n", ""]);
// Exports
module.exports = exports;
